/**
 * Character definitions for Homerun game
 * Used across player setup, game arena, and AI configuration
 */

export interface Character {
  id: number;
  name: string;
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
}

/**
 * All available character options
 * Centralized definition to ensure consistency across the app
 */
export const CHARACTERS: Character[] = [
  {
    id: 0,
    name: 'Coral Buddy',
    primaryColor: '#FF6B8A',
    secondaryColor: '#FF8FA3',
    accentColor: '#FFB3C1'
  },
  {
    id: 1,
    name: 'Ocean Friend',
    primaryColor: '#4ECDC4',
    secondaryColor: '#45B7B8',
    accentColor: '#6C7B7F'
  },
  {
    id: 2,
    name: 'Purple Pal',
    primaryColor: '#9B59B6',
    secondaryColor: '#8E44AD',
    accentColor: '#BB8FCE'
  },
  {
    id: 3,
    name: 'Forest Mate',
    primaryColor: '#2ECC71',
    secondaryColor: '#27AE60',
    accentColor: '#82E0AA'
  },
  {
    id: 4,
    name: 'Midnight Companion',
    primaryColor: '#2C3E50',
    secondaryColor: '#34495E',
    accentColor: '#5D6D7E'
  },
  {
    id: 5,
    name: 'Sunny Sidekick',
    primaryColor: '#F39C12',
    secondaryColor: '#E67E22',
    accentColor: '#F8C471'
  }
];

/**
 * Get character by ID with fallback to first character
 */
export const getCharacterById = (id: number | null | undefined): Character => {
  const character = CHARACTERS.find(c => c.id === id);
  return character || CHARACTERS[0];
};

/**
 * Get default character (Coral Buddy)
 */
export const getDefaultCharacter = (): Character => {
  return CHARACTERS[0];
};
